import { LOCAL_STORAGE_TOKEN_KEY } from '@ui/constants';
import { safeParseJson } from '@ui/utils';
const REFRESH_TOKEN_COOKIE_KEY = 'zephyr_refresh_token';
function setCookie(name, value) {
    let days = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 30;
    try {
        const expires = new Date();
        expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = "".concat(name, "=").concat(value, ";expires=").concat(expires.toUTCString(), ";path=/;samesite=strict");
    } catch (unused) {
    // ignore if document not available (SSR/tests)
    }
}
function getCookie(name) {
    try {
        const nameEQ = "".concat(name, "=");
        const ca = document.cookie.split(';');
        for (const cookie of ca){
            let c = cookie;
            while(c.startsWith(' ')){
                c = c.substring(1, c.length);
            }
            if (c.startsWith(nameEQ)) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return null;
    } catch (unused) {
        // ignore if document not available (SSR/tests)
        return null;
    }
}
function deleteCookie(name) {
    try {
        document.cookie = "".concat(name, "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;");
    } catch (unused) {
    // ignore if document not available (SSR/tests)
    }
}
export function setAccessToken(accessToken, refreshToken) {
    if (!accessToken) {
        localStorage.removeItem(LOCAL_STORAGE_TOKEN_KEY);
        deleteCookie(REFRESH_TOKEN_COOKIE_KEY);
        return;
    }
    localStorage.setItem(LOCAL_STORAGE_TOKEN_KEY, JSON.stringify({
        access_token: accessToken,
        refresh_token: refreshToken
    }));
    if (refreshToken) {
        setCookie(REFRESH_TOKEN_COOKIE_KEY, refreshToken);
    }
}
export function getAccessToken() {
    var _ref;
    const token = localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
    if (!token) {
        return '';
    }
    const parsed = safeParseJson(token);
    return (_ref = parsed === null || parsed === void 0 ? void 0 : parsed.access_token) !== null && _ref !== void 0 ? _ref : '';
}
export function getRefreshToken() {
    const token = localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
    if (token) {
        const parsed = safeParseJson(token);
        const refreshToken = parsed === null || parsed === void 0 ? void 0 : parsed.refresh_token;
        if (refreshToken) {
            return refreshToken;
        }
    }
    const cookieRefreshToken = getCookie(REFRESH_TOKEN_COOKIE_KEY);
    return cookieRefreshToken !== null && cookieRefreshToken !== void 0 ? cookieRefreshToken : '';
}
